import upscaleLogo from "src/assets/images/upscaleLogo.png";

type UpscaleLogoProps = {
  className?: string;
};

const UpscaleLogo = ({ className = "h-7 w-auto object-contain" }: UpscaleLogoProps) => (
  <img src={upscaleLogo} alt="UpScale" className={className} draggable={false} />
);

export default UpscaleLogo;
